import {Injectable} from '@angular/core';

import {ScoreBookFacadeService} from './score-book-facade.service';

@Injectable()
export class EvaluationPreloadGuard  {
  constructor(private _scoreBookFacade: ScoreBookFacadeService) {
  }

  canActivate(): boolean {
    this._scoreBookFacade.loadSchoolReportTypeAndClassAssignments();
    this._scoreBookFacade.loadAttributionsActivesForConnectedTeacher();
    return true;
  }

}
